export default {
  list: '/admin/empresa/:company/termometros',
  add: '/admin/empresa/:company/agregar-termometro',
  detail: '/admin/empresa/:company/termometros/:thermometer',
  what: '/admin/que-es-termometro',
  questions: '/admin/preguntas-encuesta',
}
